import { Component, effect, inject, OnDestroy } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidators } from '@corelabs/angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormInputComponent, FormTextareaComponent } from '@shared/forms';
import { ReflectionFacade } from '@app/store/reflection';
import { ItemSelectionService } from '../item-selection.service';

@Component({
    selector: 'app-create-reflection',
    templateUrl: './create-reflection.component.html',
    styleUrls: ['./create-reflection.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, RouterLink, ButtonModule, FormInputComponent, FormTextareaComponent],
})
export class CreateReflectionComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly reflectionFacade = inject(ReflectionFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);
    private readonly itemSelectionService = inject(ItemSelectionService);

    readonly saving = this.reflectionFacade.saving;

    readonly form = this.formBuilder.group({
        name: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        questionText: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
    });

    constructor() {
        effect(() => {
            const createdId = this.reflectionFacade.createdId();
            if (this.reflectionFacade.saved() && createdId) {
                this.itemSelectionService.select({ id: createdId, type: 'reflection' });
                this.close();
            }
        });

        effect(() => {
            if (this.reflectionFacade.saving() === false && this.reflectionFacade.saved() === false) {
                this.form.enable();
            }
        });
    }

    ngOnDestroy(): void {
        this.reflectionFacade.clear();
    }

    onSubmit(): void {
        this.form.markAllAsTouched();

        if (this.form.valid) {
            this.form.disable();
            this.reflectionFacade.createReflection(this.form.getRawValue());
        }
    }

    close(): void {
        this.router.navigate([{ outlets: { dialog: null } }]);
    }
}
